export default "__VITE_ASSET__a5230bf9__"